<template>
	<footer :class="[getRouteLeave ? 'disable' : '']" v-if="getFooterData">
		<div class="footer-container">
			<div class="socials">
				<ul>
					<li v-for="link in getFooterData.body.items" key="social">
						<a :href="link.url" target="_blank">
							<i :class="`icon-${link.title}`"></i>
						</a>
					</li>
				</ul>
			</div>

			<p class="copyright">
				Copyright © All rights reserved.
			</p>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'footer-comp',
		created () {
			if (!this.$store.getters.getFooterData) {
				this.get('socials', 'setFooterData')
			}
		},
		computed: {
			getFooterData () {
				return this.$store.getters.getFooterData
			},
			getRouteLeave () {
				return this.$store.getters.getRouteLeave
			}
		}
	}
</script>

<style lang="scss">
	footer {
		display: flex;
		justify-content: center;
		width: 100%;
		padding: 50px 0;
		@include transition(all .4s);

		&.disable {
			opacity: 0;
		}

		ul {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0;
			margin: 0;
		}

		li {
			margin-right: 30px;
			list-style-type: none;

			&:last-child {
				margin-right: 0;
			}
		}

		a {
			@include fontSize(20);
			@include transition(all .4s);

			&:hover {
				opacity: .5;
			}
		}
	}

	.footer-container {
		opacity: 0;
		animation: footerAppear .5s ease-in-out forwards;
	}

	@keyframes footerAppear {
		0% { opacity: 0; }
		100% { opacity: 1; }
	}

	.copyright {
		margin: 30px 0 0;
		@include fontSize(10);
	}
</style>



// WEBPACK FOOTER //
// src/vue/components/common/footer/Footer.vue?452475e7